/*
 * MAIN SCRIPTS ENTRY FILE
 */

// Dependencies
require('slick-carousel');
require('jquery-lazy');
//require('jquery-backstretch');
require("waypoints/lib/jquery.waypoints.js");
//require("waypoints/lib/shortcuts/sticky.js");
//require('sticky-kit/dist/sticky-kit.js'); // much better than waypoints-sticky in most cases

//require("sticky-sidebar");

// cherry-picked jQuery UI functions 
require("jquery-ui/ui/focusable.js");
require("jquery-ui/ui/tabbable.js");
require("jquery-ui/ui/unique-id.js");

// Old bundle files which have not been changes to npm dependencies:
require("./src/ThirdParty/jquery.malihu.PageScroll2id.js");
require("./src/ThirdParty/jquery.fancybox.min.js"); // installed but not imported yet -- need to figure out CSS. For now still using local copy 
//require("./src/ThirdParty/svg-inject.js");

// MAIN SCRIPTS
//require("./src/tracking.js"); // DEC / Insight / GTM scripts
require("./src/master.js");
//require("./src/mobile-menu.js");